export function assert<T>(val: T|null|undefined, msg = ''): asserts val is T {
  if (!val) {
    if (!msg) {
      msg = 'Unexpected falsey value ' + val;
    }
    throw new Error(msg);
  }
}

export function checkExhaustive(val: never) {
  console.error('Check exhaustive called with value: ' + val);
}